var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessLangCloud9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 43,
    viewBox: "0 0 140 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-19 58H138.642C139.978 58 139.637 56.8992 140 55.6715C137.026 44.5515 118.645 50.5029 110.467 50.8398C108.137 41.1106 103.19 19.9984 88.9015 30.8797C89.7388 14.7631 78.2131 2.59911 62.7321 0.37151C43.5429 -2.39025 38.1577 10.6142 34.101 27.1397C21.335 20.1605 2.78805 31.9543 1.18921 46.2963C-6.9878 42.096 -17.2749 48.3798 -19 58Z",
    fill: "#FFEBD8",
    fillOpacity: 0.67
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessLangCloud9);
export default __webpack_public_path__ + "static/media/assess-lang-cloud9.d76242e71d0605859af752d3330c6c26.svg";
export { ForwardRef as ReactComponent };